export const RECEBIMENTO_READ_ONLY = 0;
export const RECEBIMENTO_SELECT_TANKS = 1;
export const RECEBIMENTO_WAIT_FINISH = 2;
